export const STAFF_SUB_TYPES = Object.freeze({
  RNAC: '1',
  LNAC: '2',
});
